export default __webpack_public_path__ + "ring_logo.a2e856ad.png";